<div class="document-list-container">
  <table mat-table [dataSource]="documentDataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/dokumenty/szczegoly', element.uuid]">{{element.documentName ? element.documentName : element.filename}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Typ</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceProtocolDate">
      <th mat-header-cell *matHeaderCellDef> Data przekazania/zwrotu urządzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.deviceProtocolDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef> Data modyfikacji </th>
      <td mat-cell *matCellDef="let element">
        {{element.updatedAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.user?.username }}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerOrOfwca">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="contractType">
      <th mat-header-cell *matHeaderCellDef> Typ umowy</th>
      <td mat-cell *matCellDef="let element">
        {{element.contract?.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany?.id]">
          {{element.insuranceCompany?.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="openDocument(element)"
                mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>
        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">
          <mat-icon>download</mat-icon>
        </button>
          <button [disabled]="!(userPermissions | async).document.delete"  mat-icon-button color="warn" (click)="deleteDocument(element)">  <mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
